// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthorHeader-cls1__dfa8f6c58a82a7302b42{/*!*/}.AuthorHeader-cls2___7eef2d79e05accedd2b{display:flex;overflow:hidden;margin-left:-16px;border-radius:16px;border-radius:var(--radius-corner-radius-default, 16px);border:1px solid #141413;border:1px solid var(--stroke-dark, #141413);background:#fff;background:var(--background-white, #fff)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AuthorHeader-cls1__dfa8f6c58a82a7302b42",
	"cls2": "AuthorHeader-cls2___7eef2d79e05accedd2b AuthorHeader-cls1__dfa8f6c58a82a7302b42"
};
export default ___CSS_LOADER_EXPORT___;
